import { toggle_loader, disable_loader } from "./loader.js";
import ScrollReveal from "scrollreveal";
document.addEventListener("click", function (event) {
  if (!event.target.matches("#load_more")) return;
  event.preventDefault();
  var btn = event.target,
      paged = btn.hasAttribute("data-page") ? parseInt(btn.getAttribute("data-page")) : 2;
  btn.classList.add("disabled");
  toggle_loader();
  var xhttp = new XMLHttpRequest();

  xhttp.onreadystatechange = function () {
    if (this.readyState == 4 && this.status == 200) {
      var json = JSON.parse(this.responseText);

      if (json.success) {
        var data = json.data; // Add HTML to DOM

        document.querySelector(".careers-loop").innerHTML += data.html; // Increase page to load counter

        btn.setAttribute("data-page", ++paged); // Hide load more button if last element

        if (data.last) {
          btn.remove();
        } else {
          btn.classList.remove("disabled");
        }
      }

      ScrollReveal().sync();
      disable_loader();
    }
  };

  xhttp.open("GET", ajax_object.ajax_url + "?action=load_more&page=" + paged + "&posts=" + ajax_object.posts, true);
  xhttp.send();
});